import React from 'react'
import styled from '@emotion/styled'
import { Theme, Tooltip, Typography } from '@yuno/design-system-web'
import { Link } from 'react-router-dom'
import Routes from '../../utils/routes'
import { connectionCategory } from '../../utils/constants'

type StyledProps = { theme?: Theme; isNewConnection?: boolean }

type ConnectionItemProps = {
  right?: React.ReactElement | string | string[]
  fullWidth?: boolean
  connection: any
  isNewConnection?: boolean
}

const Wrapper = styled.div<{ fullWidth?: boolean }>`
  max-width: ${({ fullWidth }) => (fullWidth ? '100%' : '340px')};
`

const ImgWrapper = styled.div<{
  width?: string
  height?: string
  theme?: Theme
}>`
  width: ${({ width }) => width || '60px'};
  height: ${({ height }) => height || '60px'};
  box-sizing: border-box;
  padding: 10px;
  background: ${({ theme }) => theme.palette.grey[1]};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const HeaderStyled = styled.div`
  display: flex;
  align-items: center;
`

export const Title = styled(Typography)<StyledProps>`
  margin-left: 16px;
  margin-right: 16px;
  flex: 1;
  color: ${({ theme }) => theme.palette.neutral.black};
  font-size: ${({ theme }) => theme.typography.m.regular.fontSize};
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

export const Description = styled(Typography)<StyledProps>`
  color: ${({ theme }) => theme.palette.grey[5]};
  font-size: ${({ theme }) => theme.typography.tiny.regular.fontSize};
  overflow: hidden;
  ${({ isNewConnection }) =>
    !isNewConnection
      ? ` height: 36px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;`
      : null};
`

const MoreInfoLink = styled(Link)<StyledProps>`
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: 12px;
  ${({ isNewConnection }) =>
    isNewConnection
      ? ` text-decoration: none;`
      : `text-decoration: underline ${({ theme }) =>
          theme.palette.primary.main};
      font-family: Inter;
      font-style: normal;
      font-weight: bold;
      cursor: pointer;`};
`

const MoreInfoSpan = styled('span')<StyledProps>`
  color: ${({ theme }) => theme.palette.primary.main};
  font-family: Inter;
  font-style: normal;
`

const DescriptionMain = styled('main')`
  margin-top: 16px;
`

const ConnectionItem = ({
  right,
  fullWidth,
  connection,
  isNewConnection,
}: ConnectionItemProps) => {
  return (
    <Wrapper fullWidth={fullWidth}>
      <HeaderStyled>
        <ImgWrapper>
          <img width="40px" height="40px" src={connection?.icon} />
        </ImgWrapper>
        <Tooltip disableInteractive title={connection?.name} color="default">
          <Title>{connection?.name}</Title>
        </Tooltip>
        {connection.more_info_url && (
          <MoreInfoLink target="_blank" to={connection.more_info_url}>{right}</MoreInfoLink>
        )}
      </HeaderStyled>
      {connection?.description && (
        <DescriptionMain>
          <Tooltip title={connection?.description} color="default">
            <Description isNewConnection={isNewConnection}>
              {connection?.description}
            </Description>
          </Tooltip>
        </DescriptionMain>
      )}
    </Wrapper>
  )
}

export default ConnectionItem
